export enum TICKET_TYPE {
  PHYSICAL_NETWORK_CONDITION = "PHYSICAL_NETWORK_CONDITION",
  CONNECTION_FAILURE_ISSUE = "CONNECTION_FAILURE_ISSUE",
}
